export const slideInFromTopNFadeNZoom = (endOffset = 0) => ({
	'0%': {
		transform: 'translateY(-8px) scale(0.95)',
		opacity: 0,
	},
	'100%': {
		transform: `translateY(${endOffset}px) scale(1)`,
		opacity: 1,
	},
});
export const slideInFromBottomNFadeNZoom = (endOffset = 0) => ({
	'0%': {
		transform: 'translateY(8px) scale(0.95)',
		opacity: 0,
	},
	'100%': {
		transform: `translateY(${endOffset}px) scale(1)`,
		opacity: 1,
	},
});
export const slideInFromLeftNFadeNZoom = (endOffset = 0) => ({
	'0%': {
		transform: 'translateX(-8px) scale(0.95)',
		opacity: 0,
	},
	'100%': {
		transform: `translateX(${endOffset}px) scale(1)`,
		opacity: 1,
	},
});
export const slideInFromRightNFadeNZoom = (endOffset = 0) => ({
	'0%': {
		transform: 'translateX(8px) scale(0.95)',
		opacity: 0,
	},
	'100%': {
		transform: `translateX(${endOffset}px) scale(1)`,
		opacity: 1,
	},
});
export const fadeOutZoomOut = {
	'0%': {
		transform: 'scale(1)',
		opacity: 1,
	},
	'100%': {
		transform: 'scale(0.95)',
		opacity: 0,
	},
};

export const fadeInZoomIn = {
	from: {
		transform: 'scale(0.95)',
		opacity: 0,
	},
	to: {
		transform: 'scale(1)',
		opacity: 1,
	},
};

export const fadeIn = {
	from: {
		opacity: 0,
	},
	to: {
		opacity: 1,
	},
};

export const fadeOut = {
	from: {
		opacity: 1,
	},
	to: {
		opacity: 0,
	},
};
